import { useTranslation } from "react-i18next";
import { ALL_OPTION_VALUE, type FilterWithOption } from "~/hooks/useFilter";
import { ControlledCombobox } from "~/molecules/ControlledCombobox";
import { FiltersPanel } from "./FiltersPanel";

interface SelectFiltersPanelProps<T> {
  filters: FilterWithOption<T>[];
  onSelectFilter: (filterId: string, optionIds: string[]) => void;
}

/** Sidebar counterpart to FilterPopover, for the same useFilter model. */
export function SelectFiltersPanel<T>({
  filters,
  onSelectFilter,
}: SelectFiltersPanelProps<T>) {
  const { t } = useTranslation();

  return (
    <FiltersPanel>
      {filters.map((filter) => (
        <div key={filter.id} className="space-y-1">
          <p className="text-sm font-medium">{filter.label}</p>
          {filter.isMulti ? (
            <ControlledCombobox
              isMulti
              options={filter.options}
              value={filter.optionIds}
              placeholder={
                filter.optionIds.length === 0
                  ? t(($) => $.commons.select)
                  : t(($) => $.library.filters.selectedCount, {
                      count: filter.optionIds.length,
                    })
              }
              onChange={(optionIds) => onSelectFilter(filter.id, optionIds)}
            />
          ) : (
            <ControlledCombobox
              options={filter.options}
              value={filter.optionIds[0] ?? ALL_OPTION_VALUE}
              onChange={(optionId) => onSelectFilter(filter.id, [optionId])}
            />
          )}
        </div>
      ))}
    </FiltersPanel>
  );
}
